var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['leaders__tabs', (!_vm.isMain) ? 'leaders__tabs_small m-0' : ''],style:((_vm.isMain) ? 'margin-left: 0;' : '')},[_vm._l((_vm.tabs),function(tab,i){return (_vm.isMain)?_c('router-link',{key:i,class:[
      'leaders__tab', 'leaders__tab_main', _vm.activeTab === tab.name ? 'active' : ''
    ],attrs:{"to":_vm.tabRoute(tab.name)}},[_vm._v("\n    "+_vm._s(tab.name.charAt(0).toUpperCase() + tab.name.slice(1))+"\n  ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.tabs),function(tab,i){return (!_vm.isMain)?_c('link-event',{key:i,class:[
      'leaders__tab', 'leaders__tab_round', _vm.isActive(tab)
    ],attrs:{"round":tab}},[_vm._v("\n    "+_vm._s((_vm.isEventPage && tab.name == 'Final') ? 'Final round'  
      : (_vm.isEventPage && tab.name && tab.name.toLowerCase().includes('run-off') 
        ? tab.name.toUpperCase() 
        : tab.name))+"\n  ")]):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81cea752","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Leaders/Listing/components/RoundTabs.vue
// module id = 1031
// module chunks = 30